/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanApiRespModel } from '../../models/boolean-api-resp-model';
import { DeleteRequestModel } from '../../models/delete-request-model';

export interface ApiWorklistDeleteRequestPost$Params {
      body?: DeleteRequestModel
}

export function apiWorklistDeleteRequestPost(http: HttpClient, rootUrl: string, params?: ApiWorklistDeleteRequestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiWorklistDeleteRequestPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanApiRespModel>;
    })
  );
}

apiWorklistDeleteRequestPost.PATH = '/api/Worklist/DeleteRequest';
